import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=09ce2052&"
import script from "./CardHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_rqhk6tgffcjxa27soxhh2o2ymu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports